import { $fetch } from '@/boot/fetch'
import { DELIVERY, PICKUP } from '@/constants/fulfillment.const'
import { enrichAuctionItem } from '@/utils/product.util'

const ENDPOINT = '/orders'

function enrichOrderItems(items) {
  return items.map(item => {
    item.isDeliveryFulfillment = item.fulfillmentMethod === DELIVERY
    item.isPickupFulfillment = item.fulfillmentMethod === PICKUP
    let status = 'PROCESSING'

    if (item.isDeliveryFulfillment) {
      const hasBoxes = item.shipmentBoxes && item.shipmentBoxes.length > 0
      const allBoxesShipped = item.shipmentBoxes?.every(box => ['in_transit', 'out_for_delivery'].includes(box.trackingStatus))
      const allBoxesDelivered = item.shipmentBoxes?.every(box => box.trackingStatus === 'delivered')

      if (hasBoxes && (allBoxesShipped || allBoxesDelivered)) {
        status = allBoxesDelivered ? 'DELIVERED' : 'IN_TRANSIT'
      }
    } else {
      if (item.fulfilled) {
        status = 'READY_FOR_PICKUP'
      }

      if (item.pickedUp) {
        status = 'PICKED_UP'
      }
    }

    item.fulfillmentStatus = status

    // flatten item data and parse
    return enrichAuctionItem({ ...item.auctionItem, ...item })
  })
}

function enrichOrders(orders) {
  return orders.map(order => {
    order.lineItems = enrichOrderItems(order.lineItems).map(item => ({ ...item, financialStatus: order.financialStatus }))

    let status = 'PROCESSING'

    if (order.lineItems.every(item => item.fulfilled)) {
      status = 'FULFILLED'
    } else if (order.lineItems.some(item => item.fulfilled)) {
      status = 'PARTIALLY_FULFILLED'
    }

    order.isPaid = order.financialStatus === 'PAID'
    order.status = status
    order.totalOriginalLineItemPrice = order.lineItems.reduce((acc, item) => acc + item.originalPrice, 0)
    order.totalSavings = order.totalOriginalLineItemPrice - order.totalPrice

    return order
  })
}

export default {
  async getBulk(params = {}) {
    if (!params.limit) {
      params.limit = 5
      params.offset = 0
    }
    const resp = await $fetch.peg(ENDPOINT, { params })
    resp.orders = enrichOrders(resp.orders)
    return resp
  },
  async getSingle(id) {
    const resp = await $fetch.peg(`${ENDPOINT}/${id}`)
    if (resp.order) {
      resp.order = enrichOrders([resp.order])[0]
    }
    return resp
  },
}
